import React, { createContext, useState, useEffect } from "react";
import axios from "axios";
import ApiUrl from "../Environment/ApiUrl";

export const RatesContext = createContext({
  rates: {
    gold_1g_rate: "Loading...",
    silver_10g_rate: "Loading...",
    cold_coin_rate: "Loading...",
    silver_coin_rate: "Loading...",
  },
  updateRates: () => {},
});

export const RatesProvider = ({ children }) => {
  const [rates, setRates] = useState({
    gold_1g_rate: "Loading...",
    silver_10g_rate: "Loading...",
    cold_coin_rate: "Loading...",
    silver_coin_rate: "Loading...",
  });

console.log("the data was setrates", rates);


  useEffect(() => {
    const fetchRates = async () => {
      try {
        const response = await axios.get(`${ApiUrl}/Api/daily_rates.php`);
        const today = new Date()
          .toLocaleDateString("en-GB")
          .replace(/\//g, "-");
        const todayRate = response.data.data.find(
          (rate) => rate.date === today
        );

        if (todayRate) {
          setRates({
            gold_1g_rate: todayRate.gold_1g_rate,
            silver_10g_rate: todayRate.silver_10g_rate,
            cold_coin_rate: todayRate.cold_coin_rate,
            silver_coin_rate: todayRate.silver_coin_rate,
          });
        }
      } catch (error) {
        console.error("Error fetching rates:", error);
        setRates({
          gold_1g_rate: "Error",
          silver_10g_rate: "Error",
          cold_coin_rate: "Error",
          silver_coin_rate: "Error",
        });
      }
    };

    fetchRates();
    const interval = setInterval(fetchRates, 5000);
    return () => clearInterval(interval);
  }, []);

  const updateRates = (newRates) => {
    setRates((prevRates) => ({
      ...prevRates,
      ...newRates,
    }));
  };

  return (
    <RatesContext.Provider value={{ rates, updateRates }}>
      {children}
    </RatesContext.Provider>
  );
};
